export const LIVE_SCENE_OPTIONS = [
  { id: 'spotlight', labelEs: 'Spotlight', labelEn: 'Spotlight' },
  { id: 'afterglow', labelEs: 'Afterglow', labelEn: 'Afterglow' },
  { id: 'velvet', labelEs: 'Velvet', labelEn: 'Velvet' },
  { id: 'ivory', labelEs: 'Ivory', labelEn: 'Ivory' },
  { id: 'pulse', labelEs: 'Pulse', labelEn: 'Pulse' },
];

export const DEMO_COVERS = [
  'https://images.pexels.com/photos/1763068/pexels-photo-1763068.jpeg?auto=compress&cs=tinysrgb&w=800',
  'https://images.pexels.com/photos/6311811/pexels-photo-6311811.jpeg?auto=compress&cs=tinysrgb&w=800',
  'https://images.unsplash.com/photo-1690013429722-87852aae164b?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1768885511419-db1b61b02d0d?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1633465781723-72167577aa0b?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1552672275-b9c9cfd4814c?auto=format&fit=crop&w=800&q=80',
];

/* ═══════════════════════════════════════════════════════════════════════════════
   MARCOS DE FAMA — League of Legends Style Tier System
   
   7 Tiers based on accumulated Pulse Points (host only, live metrics only):
   - Bronze (0-99): Starting tier
   - Silver (100-299): Consistent streaming
   - Gold (300-699): Growing audience
   - Platinum (700-1499): Established presence
   - Diamond (1500-2999): Top performer
   - Master (3000-5999): Elite status
   - Challenger (6000+): Legendary
═══════════════════════════════════════════════════════════════════════════════ */

export const FAME_TIERS = {
  bronze: { 
    id: 'bronze', 
    name: 'Bronce', 
    nameEn: 'Bronze',
    minPoints: 0, 
    maxPoints: 99,
    color: '#8B5A2B',
    borderClass: 'ring-2 ring-[#8B5A2B]/60',
    glowClass: '',
    textClass: 'text-[#8B5A2B]',
    effect: 'none'
  },
  silver: { 
    id: 'silver', 
    name: 'Plata', 
    nameEn: 'Silver',
    minPoints: 100, 
    maxPoints: 299,
    color: '#A8A8A8',
    borderClass: 'ring-2 ring-[#A8A8A8]/70',
    glowClass: 'shadow-[0_0_8px_rgba(168,168,168,0.2)]',
    textClass: 'text-[#C0C0C0]',
    effect: 'shimmer'
  },
  gold: { 
    id: 'gold', 
    name: 'Oro', 
    nameEn: 'Gold',
    minPoints: 300, 
    maxPoints: 699,
    color: '#D4A853',
    borderClass: 'ring-2 ring-[#D4A853]/70',
    glowClass: 'shadow-[0_0_12px_rgba(212,168,83,0.25)]',
    textClass: 'text-[#D4A853]',
    effect: 'glow'
  },
  platinum: { 
    id: 'platinum', 
    name: 'Platino', 
    nameEn: 'Platinum',
    minPoints: 700, 
    maxPoints: 1499,
    color: '#4ECDC4',
    borderClass: 'ring-2 ring-[#4ECDC4]/70',
    glowClass: 'shadow-[0_0_16px_rgba(78,205,196,0.3)]',
    textClass: 'text-[#4ECDC4]',
    effect: 'frost'
  },
  diamond: { 
    id: 'diamond', 
    name: 'Diamante', 
    nameEn: 'Diamond',
    minPoints: 1500, 
    maxPoints: 2999,
    color: '#45B7D1',
    borderClass: 'ring-2 ring-[#45B7D1]/80',
    glowClass: 'shadow-[0_0_20px_rgba(69,183,209,0.4)]',
    textClass: 'text-[#45B7D1]',
    effect: 'sparkle'
  },
  master: { 
    id: 'master', 
    name: 'Master', 
    nameEn: 'Master',
    minPoints: 3000, 
    maxPoints: 5999,
    color: '#9B59B6',
    borderClass: 'ring-2 ring-[#9B59B6]/80',
    glowClass: 'shadow-[0_0_24px_rgba(155,89,182,0.5)]',
    textClass: 'text-[#9B59B6]',
    effect: 'pulse'
  },
  challenger: { 
    id: 'challenger', 
    name: 'Challenger', 
    nameEn: 'Challenger',
    minPoints: 6000, 
    maxPoints: Infinity,
    color: '#E74C3C',
    borderClass: 'ring-2 ring-[#E74C3C]/90 ring-offset-1 ring-offset-[#D4A853]/30',
    glowClass: 'shadow-[0_0_32px_rgba(231,76,60,0.5),0_0_16px_rgba(212,168,83,0.3)]',
    textClass: 'text-[#E74C3C]',
    effect: 'flames'
  },
};

export const FAME_TIER_ORDER = ['bronze', 'silver', 'gold', 'platinum', 'diamond', 'master', 'challenger'];

export function getFameTierFromPoints(points = 0) {
  if (points >= 6000) return FAME_TIERS.challenger;
  if (points >= 3000) return FAME_TIERS.master;
  if (points >= 1500) return FAME_TIERS.diamond;
  if (points >= 700) return FAME_TIERS.platinum;
  if (points >= 300) return FAME_TIERS.gold;
  if (points >= 100) return FAME_TIERS.silver;
  return FAME_TIERS.bronze;
}

export function getFameTierProgress(points = 0) {
  const tier = getFameTierFromPoints(points);
  const nextTierIndex = FAME_TIER_ORDER.indexOf(tier.id) + 1;
  const nextTier = nextTierIndex < FAME_TIER_ORDER.length ? FAME_TIERS[FAME_TIER_ORDER[nextTierIndex]] : null;
  
  if (!nextTier) return { tier, progress: 100, pointsToNext: 0 };
  
  const rangeStart = tier.minPoints;
  const rangeEnd = nextTier.minPoints;
  const progress = Math.min(100, Math.floor(((points - rangeStart) / (rangeEnd - rangeStart)) * 100));
  const pointsToNext = rangeEnd - points;
  
  return { tier, nextTier, progress, pointsToNext };
}

/* ── Fame Frame CSS Classes ── */
export function fameBorderClass(fameTier) {
  const tier = typeof fameTier === 'string' ? FAME_TIERS[fameTier] : fameTier;
  return tier ? `${tier.borderClass} ${tier.glowClass}` : FAME_TIERS.bronze.borderClass;
}

export function fameTextClass(fameTier) {
  const tier = typeof fameTier === 'string' ? FAME_TIERS[fameTier] : fameTier;
  return tier?.textClass || FAME_TIERS.bronze.textClass;
}

export function formatEuro(value) {
  return `${Number(value || 0).toFixed(2)}\u20AC`;
}

export function toneByScene(scene = 'spotlight') {
  const map = {
    afterglow: 'from-[#2a1d18] via-[#110d0d] to-[#060606]',
    velvet: 'from-[#1a1419] via-[#09080c] to-[#050505]',
    ivory: 'from-[#2a2419] via-[#0d0c0a] to-[#040404]',
    pulse: 'from-[#231412] via-[#0a0808] to-[#050505]',
  };
  return map[scene] || 'from-[#221b11] via-[#0b0907] to-[#050505]';
}

export function tierGlow(tier) {
  switch (tier) {
    case 'diamond':
      return 'ring-2 ring-[#d4a853]/50 shadow-[0_0_24px_rgba(212,168,83,0.25)]';
    case 'spotlight':
      return 'ring-1 ring-[#d4a853]/30 shadow-[0_0_12px_rgba(212,168,83,0.12)]';
    case 'rising':
      return 'ring-1 ring-white/15';
    default:
      return 'ring-1 ring-white/8';
  }
}

export function demoCover(index) {
  return DEMO_COVERS[index % DEMO_COVERS.length];
}

export function tierLabel(session) {
  const map = { base: 'Open', rising: 'Rising', spotlight: 'Spotlight', diamond: 'Diamond' };
  return map[session?.presence_tier || 'base'] || map.base;
}

export function formatLabel(session) {
  return (session?.session_format || 'room') === 'show' ? 'Pulse Show' : 'Pulse Room';
}

export function liveCardClass(session) {
  return tierGlow(session?.presence_tier || 'base');
}

export const TIER_NAME_COLORS = {
  diamond: 'text-[#d4a853]',
  spotlight: 'text-[#c9a54e]/80',
  rising: 'text-white/60',
  base: 'text-white/35',
};

export const TIER_AVATAR_RING = {
  diamond: 'border-[#d4a853]/50',
  spotlight: 'border-[#c9a54e]/30',
  rising: 'border-white/15',
  base: 'border-white/8',
};
